import Vue from "vue";

const state = Vue.observable({ iframesrc: "" });

export default state;
